"use client"
import gsap from "gsap"
import Image from 'next/image'
import React, { useEffect, useRef } from 'react'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"

gsap.registerPlugin(SplitText, ScrollTrigger)

export default function PreFooter() {

  const preFooterRef = useRef(null)

  useEffect(() => {
    const preFooter = preFooterRef.current
    if (!preFooter) return

    const title = preFooter.querySelector("h2")
    const image = preFooter.querySelector(".reveal-image")
    const paragraphs = preFooter.querySelectorAll("p")

    if (!title || !image || paragraphs.length === 0) return

    // Split the title into lines and characters
    const split = new SplitText(title, { types: "lines,chars", autoSplit: true })

    // Title animation timeline
    const preFooterTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: title,
        start: "top 60%",
        toggleActions: "play none none none"
      }
    })

    preFooterTimeline
      .from(split.lines, {
        opacity: 0,
        y: 50,
        duration: 0.5,
        stagger: 0.1,
        ease: "power3.out"
      })
      .from(
        split.chars,
        {
          y: 100,
          opacity: 0,
          stagger: 0.015,
          ease: "power3.out"
        },
        "-=0.4"
      )

    // Image reveal
    gsap.fromTo(
      image,
      {
        clipPath: "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)",
        opacity: 0
      },
      {
        clipPath: "polygon(0 0%, 100% 0%, 100% 100%, 0 100%)",
        opacity: 1,
        duration: 0.5,
        delay: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: image,
          start: "top 95%"
        }
      }
    )

    // Paragraph stagger
    gsap.from(paragraphs, {
      y: 50,
      opacity: 0,
      stagger: 0.2,
      duration: 0.75,
      ease: "power3.out",
      scrollTrigger: {
        trigger: preFooter,
        start: "top 75%"
      }
    })

    // Ensure everything is recalculated
    setTimeout(() => ScrollTrigger.refresh(), 0)

    // Cleanup
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
      gsap.killTweensOf([title, image, paragraphs])
      split.revert()
    }
  }, [])



  return (
    <section className="relative linear-orange-red text-white text-center" ref={preFooterRef}>
      <div className="container py-32 flex flex-col items-center max-w-screen-2xl mx-auto">
        <p className="mb-12">We&apos;re here </p>
        <h2>
          <div className="text-[10vw] 2xl:text-[10rem] uppercase font-bold">To Make You</div>
          <div className="text-[25vw] lg:text-[29vw] 2xl:text-[29rem] uppercase font-bold leading-none">Smile</div>
        </h2>
        <img src="/img/white-smile.svg" alt="Icon of a smile" width={83} height={77} className="scale-75 lg:scale-100 reveal-image" />
      </div>
    </section>
  )
}
